/* 
  页面指定内容导航

  name  页面内需要导航元素(例如：.floor，
        指定元素可以自定义导航名称，默认是元素序号，设置该元素name属性，
        例如：<div id="gxyw" name="导航一<br>孵化" class="floor"></div>)

  json  gotop（是否需要回滚顶部功能）
        mtop（页面滚动多少像素才显示回滚顶部按钮）
*/

export class contentNav{

  constructor(name,json) {
    this.name = name;
    //this.json = json;
    this.lis = document.querySelectorAll(name + ' .floor');
    this.nav = document.querySelectorAll(".sNav li");
    this.init();
  }

  init(){
    const that = this;

    let conDiv = document.querySelector('.sNav');
    //conDiv.className = 'sNav';
    //conDiv.appendChild(document.createElement('ul'));


    // 生成导航元素
    that.lis.forEach((item,index) => {
      let liTxt = document.createElement('li');
      liTxt.innerHTML = item.getAttribute('name')||index+1;
      conDiv.querySelector('.navLi').appendChild(liTxt);
    });

    // 是否生成滚动到顶部元素
    // if(that.json.gotop){
    //   let gpLi = document.createElement('li');
    //   gpLi.className = 'backTop';
    //   let gpI = document.createElement('i');
    //   gpI.className = 'icons-up';
    //   gpLi.appendChild(gpI);
    //   conDiv.querySelector('ul').appendChild(gpLi);
    // }

    // 添加导航元素到页面
    document.querySelector(that.name).appendChild(conDiv);
    //console.log()
    conDiv.style.cssText = "position:fixed;top:calc(50% - " + (conDiv.offsetHeight - 26) + "px)";

    // 导航元素点击事件
    that.nav = document.querySelectorAll(".sNav li");
    that.nav.forEach((item,index) => {

      if(item.classList != 'backTop'){
        item.onclick = () => {
          that.curindex(index);
          document.querySelector(".wrap").scrollTop = that.lis[index].offsetTop;
        }
      }else{
        item.onclick = () => {
          document.querySelector("html").scrollTop = 0;
        }
      }

    });

    //滚动事件处理
    document.querySelector(".wrap").onscroll = function(e){
      let dST = document.querySelector(".wrap").scrollTop;
      let winH = document.querySelector(".wrap").offsetHeight;

      that.lis.forEach((item,index) => {
        let h = item.offsetTop - dST;

        if(h > 0 && h < winH/2 ){
          that.curindex(index);
        }else if(dST < 50 || dST - that.lis[that.lis.length-1].offsetTop > winH/2){
          that.curindex('noli');
        }
        
      });

      // document.querySelector(".backTop").style.display = dST > that.json.mtop?'block':'none';
    }
  }

  //当前元素
  curindex(index){
    this.nav.forEach(li => {
      li.classList.remove('on');
    });
    if(index != 'noli'){
      this.nav[index].classList.add('on');
    }
  }

}


/* 
  banner轮播图
*/
export class Banner {
  constructor(name, json) {
    this.box = document.querySelector(name);
    this.json = json;
    //获取轮播图的属性
    this.outer = document.querySelector(name + ' .imgList'); //注意加空格
    this.left = document.querySelector(name + ' .left');
    this.right = document.querySelector(name + ' .right');
    this.imgs = document.querySelectorAll(name + ' .imgList li');
    this.imga = document.querySelectorAll(name + ' .imgList li a');
    this.img = document.querySelectorAll(name + ' .imgList li a img');
    //初始化
    this.timer = null; //自动播放
    this.iNow = 0;
    this.init();
    this.resetSize();
  };

  resetSize(){
    const that = this;
    window.onresize = () => {
      document.querySelectorAll(name + ' .imgList li').forEach(li => {
        li.style.width = that.box.offsetWidth + 'px';
      });
      that.outer.style.width = that.outer.children.length * that.outer.children[0].offsetWidth + 'px';
    }
  }

  init() {
    const that = this; 
    that.imgs.forEach(li => {
      li.style.width = that.box.offsetWidth + 'px';
    });
    that.imga.forEach((item,index) => {
      item.style.backgroundImage = 'url(' + that.img[index].getAttribute('src') + ')';
    });
    let uLi = that.outer.children[0].cloneNode(true);
    that.outer.appendChild(uLi);
    that.outer.style.width = that.outer.children.length * that.outer.children[0].offsetWidth + 'px';

    //点击左右滑动
    if (that.json.slide) {
      this.left.onclick = () => {
        that.leftGo()
      };
      this.right.onclick = () => {
        that.rightGo()
      };
    }

    //自动播放
    if (that.json.move) {
      that.moveGo();
      if (that.json.loop) {
        that.box.onmousemove = () => {
          clearInterval(that.timer)
        };
        that.box.onmouseout = () => {
          that.moveGo()
        }
      }
    }

    //展示小圆点
    if (that.json.nav) {
      let oOL = document.createElement('ul');
      oOL.className = 'numList';
      that.box.appendChild(oOL);
      for (let i = 0; i < that.outer.children.length - 1; i++) {
        let oLi = document.createElement('li');
        oOL.appendChild(oLi);
      }
      that.alike();
    }

  };

  leftGo() {
    this.iNow++;
    if (this.iNow >= this.outer.children.length) {
      this.iNow = 1;
      this.outer.style.transition = '0s all linear';
      this.outer.style.left = 0;
    }
    this.outer.style.left = -this.iNow * this.outer.children[0].offsetWidth + 'px';
    this.outer.style.transition = '0.6s all linear';
    this.alike();
  };

  rightGo() {
    this.iNow--;
    if (this.iNow <= -1) {
      this.iNow = this.outer.children.length - 1;
      this.outer.style.transition = '0s all linear';
      this.outer.style.left = -(this.outer.children.length - 1) * this.outer.children[0].offsetWidth + 'px';
      this.iNow = this.outer.children.length - 2;
    }
    this.outer.style.left = -this.iNow * this.outer.children[0].offsetWidth + 'px';
    this.outer.style.transition = '0.6s all linear';
    this.alike();
  };

  moveGo() {
    const that = this;
    this.timer = setInterval(() => {
      that.leftGo();
    }, that.json.speed || 2500)
  };

  //圆点对应每张图片
  alike() {
    let li = document.querySelectorAll('.numList li');
    for (let i = 0; i < li.length; i++) {
      li[i].classList.remove('on');
      if (i == this.iNow) {
        li[i].classList.add('on');
      } else {
        li[i].classList.remove('on');
      }
      //特殊：最后一张的时候是第一个
      if (this.iNow == li.length) {
        li[0].classList.add('on');
      }

      //小圆点点击事件
      if (this.json.event) {
        li[i].onclick = () => {
          for (let i = 0; i < li.length; i++) {
            li[i].classList.remove('on');
          }
          li[i].classList.add('on');
          this.outer.style.left = -i * this.outer.children[0].offsetWidth + 'px';
        }
      }

    }
  }

}


/* 
  Tab栏目切换

  nav   tab导航元素(例如：.banner .hd li)
  content   tab内容块元素（例如：.banner .bd > div）
  curindex   默认显示tab栏目序号（默认第1个栏目）
  mouseover   栏目切换鼠标动作（默认单击 click ，鼠标悬浮 mouseover）
  autoplay    是否自动切换tab（默认不自动，自动切换 autoplay）
  intervaltime    自动切换tab时间间隔
*/

export class Tab {

  constructor(nav,content,curindex,mouseover,autoplay,intervaltime,activeclass){
    this.mainDiv = nav.split(' ')[0]
    this.curindex = curindex-1 || 0
    this.mouseover = mouseover || 'click'
    this.autoplay = autoplay
    this.intervaltime = intervaltime || 2500
    this.activeclass = activeclass || 'on'
    this.nav = document.querySelectorAll(nav)
    this.content = document.querySelectorAll(content)
    this.init()
  }

  init() {
    //初始化默认显示栏目
    this.tabElement(this.curindex)

    this.nav.forEach( (item,index) => {
      this.nav[index].addEventListener(this.mouseover,function(){
        this.tabElement(index)
      }.bind(this))      
    });

    if(this.autoplay == 'autoplay'){
      this.autoPlay()
    }
  }

  // 栏目切换方法
  tabElement(index) {
    this.nav.forEach( item => {
      item.classList.remove(this.activeclass)
      this.nav[index].classList.add(this.activeclass)
    })

    this.content.forEach(item => {
      item.classList.remove(this.activeclass)
      this.content[index].classList.add(this.activeclass)
    })

    this.curindex = index
  }

  //自动循环切换
  autoPlay() {
    let playSt = setInterval(this.nextTab.bind(this),this.intervaltime)

    document.querySelector(this.mainDiv).addEventListener("mouseover",function(){
      clearInterval(playSt)
    })

    document.querySelector(this.mainDiv).addEventListener("mouseout",function(){
      playSt = setInterval(this.nextTab.bind(this),this.intervaltime);
    }.bind(this))
  }

  //下一栏目
  nextTab(){
    this.curindex++
    if(this.curindex == this.nav.length)
      this.curindex = 0
    this.tabElement(this.curindex)
  }

}


/* 
  回滚顶部

  name  回滚点击元素(例如：.backTop)
  json  mtop（页面滚动多少像素才显示回滚顶部按钮）

*/

export class goTop {
  constructor(name, json) {
    this.json = json;
    this.gotop = document.querySelector(name);
    this.init();
  };

  init(){
    const that = this;
    window.onscroll = function(e){
      that.gotop.style.display = document.querySelector("html").scrollTop > that.json.mtop?'block':'none';
      that.gotop.onclick = () => {
        document.querySelector("html").scrollTop = 0
      }
    }
  }

}


/*

 */

export class cardSroll{
  constructor(name, json) {
    this.json = json;
    this.warp = document.querySelector(name);
    this.warpUl = document.querySelector(name + ' .industryWrap .industryUl')
    this.item = document.querySelectorAll(name + ' .item')
    this.leftBtn = document.querySelector(name + ' .leftBtn');
    this.rightBtn = document.querySelector(name + ' .rightBtn');
    this.init();
  };

  init(){
    var slateX = 0;
    let subWidth = this.item[0].offsetWidth + this.json.fixWidth;
    this.json.rollNum>0?this.json.rollNum:1;
    let rollWidth = subWidth * this.json.rollNum;
    //滚多个，补齐宽度
    let fixNum = this.item.length % this.json.rollNum;
    if(fixNum!=0){
      fixNum = this.json.rollNum - fixNum
    };
    this.warpUl.style.width = subWidth * (this.item.length + fixNum) + 'px';
    
    //左滚动
    this.leftBtn.onclick = () => {
      if(slateX != 0){
        slateX = slateX + rollWidth;
        this.warpUl.style.transform =  "translateX(" + slateX +"px)";
      }
      
    }

    //右滚动
    this.rightBtn.onclick = () => {
      if(this.warpUl.offsetWidth - Math.abs(slateX - rollWidth) > this.json.visNum*this.item[0].offsetWidth){
        slateX = slateX - rollWidth;
        this.warpUl.style.transform =  "translateX(" + slateX +"px)";
      }
    };
  }
}